import React, { Component } from "react";
import { List, Button, Input, Row, Col } from "antd";
import { withRouter } from "react-router-dom";
import Axios from "../../../config/axios";
import "../../../style.css";
import "./style.css";
import withErrorHandler from "../../../hoc/withErrorHandler";
import Loading from "../../../components/Loading";

class AddLetter extends Component {
  state = {
    units: [],
  };

  componentDidMount() {
    this.fetchUnits();
  }

  fetchUnits = async () => {
    const response = await Axios.get("/units");

    const units = [];
    response.data.payload[0].children.forEach((unit) => {
      if (unit.type === "Fakultas") {
        units.push(unit);
      }
    });
    this.setState({ units });
  };

  handleShowModal = (letterhead) => {
    this.setState({ selectedLetterhead: letterhead, visibleModal: true });
  };

  hideModal = () => {
    this.setState({ visibleModal: false, selectedLetterhead: {} });
  };

  render() {
    return (
      <>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Input.Search onSearch={this.handleSearch} placeholder="Search" />
          </Col>
        </Row>

        <List
          size="large"
          dataSource={this.state.units || []}
          renderItem={(item) => (
            <List.Item>
              <Button
                type="link"
                href={`/admin/nomor-surat?unit_id=${item.id}`}
              >
                {item.name}
              </Button>
            </List.Item>
          )}
        />

        <Loading loading={this.props.loading} />
      </>
    );
  }
}

export default withRouter(withErrorHandler(AddLetter, Axios));
